/* eslint-disable */ 
export { getSeasonsRanking } from './getSeasonsRanking'
export { getScheduleResultsBySeason } from './getScheduleResultsBySeason'
export { getTeamStandingsBySeason } from './getTeamStandingsBySeason'
export { getEventAverageBySeason } from './getEventAverageBySeason' 
export { getSchoolAverageBySeason } from './getSchoolAverageBySeason'
export { getPlayerProfileBySeason } from './getPlayerProfileBySeason'
export { getSeasonsRankingByPlayer} from './getSeasonsRankingByPlayer'
export { getRankingsBySeason } from './getRankingBySeason'
export { getRankingWeeksDDBySeason } from './getRankingWeeksDDBySeason' 
export { getRankingELBySeasonWeek } from './getRankingELBySeasonWeek'
export { getEventPowerPointsBySeasonEvent } from './getEventPowerPointsBySeasonEvent'
export { getTeamPowerPointsBySeason } from './getTeamPowerPointsBySeason'
export { getPlayersBySeason } from './getPlayersBySeason'
export { getUpcomingEvents } from './getUpcomingEvents'
export { getTeams } from './getTeams'
export { getTeamPlayersBySeason } from './getTeamPlayersBySeason'


// WEBPACK FOOTER //
// ./src/components/pages/api/index.js